import axiosClient from "../axios/axiosClient";

export function getInstitutions() {
  return axiosClient.get("/institutions");
}

export function getInstitution(institutionId) {
  return axiosClient.get(`/institutions/${institutionId}`);
}

export function createInstitution(data) {
  return axiosClient.post("/institutions", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const updateInstitution = (institutionId, data) => {
  return axiosClient.post(`/institutions/${institutionId}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export function deleteInstitution(institutionId) {
  return axiosClient.delete(`/institutions/${institutionId}`);
}

export const activateInstitution = (institutionId, data) => {
  return axiosClient.patch(`/institution/${institutionId}/activate`, data);
};

export const deactivateInstitution = (institutionId, data) => {
  return axiosClient.patch(`/institution/${institutionId}/deactivate`, data);
};
